module.exports = __webpack_public_path__ + "img/图片1.246a4282.png";